import {
  ThemedFunctor, BreakpointQueryName, getTypography, TypographyName, FontWeight, AvatarColor,
} from '@doveit/bricks';
import { css } from 'styled-components';

export const rankBox: ThemedFunctor = ({ theme, $color }) => {
  const color = theme.color.foreground[$color as AvatarColor].default.low;

  return css`
    flex-shrink: 0;
    height: ${theme.remSize[400]};
    display: flex;
    justify-content: center;
    flex-direction: column;
    color: ${color};

    ${theme.breakpoints.up(BreakpointQueryName.MD)} {
      height: auto;
    }
  `;
};

export const rankLabel: ThemedFunctor = ({ theme }) => css`
  ${getTypography(theme, TypographyName.MINI, { fontWeight: FontWeight.LIGHT, textTransform: 'uppercase' })}
  text-align: center;
`;

export const rankPosition: ThemedFunctor = ({
  theme, $color, $size, $isMobile,
}) => {
  const color = theme.color.border[$color as AvatarColor].default.high;
  const laurelSvg = `
    <svg xmlns='http://www.w3.org/2000/svg' width='17' height='30' viewBox='0 0 17 30' fill='none'>
      <path
        d='M14.9037 8.8548C13.5744 8.37351 12.1059 8.4512 10.8339 9.06702C10.3056 9.32093 9.82689 9.66201 9.41497 10.0788C9.35966 9.83062 9.30817 9.57291 9.24142 9.32659L8.55486 7.03761L8.55677 7.03572C8.59491 7.03951 8.63496 7.03951 8.6731 7.03572H8.75511C10.1683 6.97698 11.4957 6.34599 12.4321 5.29246C13.3685 4.23704 13.8301 2.84812 13.7137 1.44786C13.6451 0.598981 12.9108 -0.0414635 12.0545 0.00209613C10.6432 0.064627 9.31771 0.693715 8.38323 1.74725C7.4487 2.80078 6.98526 4.18586 7.10161 5.58617C7.0997 5.63923 7.0997 5.69039 7.10161 5.74344C7.0997 5.77187 7.0997 5.80029 7.10161 5.82871V5.88366L8.20966 9.59181C9.02784 12.5629 8.79896 15.0887 7.53834 17.1008C7.13402 17.7393 6.64008 18.3134 6.06982 18.8099C6.03549 18.8307 6.00498 18.8553 5.97828 18.8857C4.5956 20.0264 2.96685 20.8335 1.218 21.2447H1.17795H1.19702H1.16078C0.485649 21.4285 0.0126477 22.0349 0.00122299 22.7303C-0.0292917 24.1249 0.512357 25.4739 1.49835 26.4668C2.48624 27.4597 3.83464 28.013 5.24022 27.9998H5.30125C6.15757 27.9865 6.84607 27.2987 6.8575 26.4498C6.86703 24.3163 5.55299 22.3968 3.5524 21.6237C4.55176 21.2125 5.4901 20.6687 6.34451 20.0074C7.31336 20.97 8.62549 21.5138 9.99484 21.5233H10.0254C11.4424 21.5157 12.7946 20.9359 13.7691 19.9165C14.3642 19.3045 14.3642 18.3343 13.7691 17.7223C12.7812 16.7181 11.4252 16.1572 10.0101 16.1667C9.73549 16.1705 9.45896 16.1932 9.18623 16.2368C9.43034 15.6096 9.60199 14.9578 9.69546 14.2927C10.1131 14.395 10.5423 14.4462 10.9714 14.4481C11.7571 14.4538 12.5333 14.2813 13.2409 13.944C14.5092 13.3245 15.4703 12.2179 15.9052 10.882C16.052 10.4803 16.0272 10.0388 15.8384 9.65608C15.6496 9.27335 15.3119 8.98553 14.9037 8.8548Z'
        fill='${color}'
      />
    </svg>
  `;
  const encodedSvg = encodeURIComponent(laurelSvg);
  const dataUrl = `url("data:image/svg+xml,${encodedSvg}")`;

  return css`
    ${getTypography(theme, ($size === 'S' || $isMobile) ? TypographyName.HEADING_4 : TypographyName.HEADING_2, { fontWeight: FontWeight.LIGHT, lineHeight: '1' })}
    display: flex;
    justify-content: center;

    strong {
      font-weight: ${FontWeight.MEDIUM};
      color: ${theme.color.foreground[$color as AvatarColor].default.low};
    }

    ${theme.breakpoints.up(BreakpointQueryName.MD)} {
      margin-top: ${$size === 'M' ? theme.remSize[50] : 0};
    }

    ${$color !== 'neutral' && `
      &::before,
      &::after {
        content: "";
        display: block;
        width: 1rem;
        height: 1.75rem;
        background-image: ${dataUrl};
        zoom: .75;
      }

      &::before {
        transform: scaleX(-1);
      }

      ${theme.breakpoints.up(BreakpointQueryName.MD)} {
        &::before,
        &::after {
          margin-top: ${theme.remSize[50]};
          zoom: ${$size === 'M' ? 1 : 0.75};
        }

        &::before {
          transform: scaleX(-1);
        }
      }
    `}
  `;
};
